const PUBLIC_URL = new URL(process.env.VELA_PLATFORM_EXT_BASE_URL || 'http://localhost')

export const VELA_PLATFORM_URL = process.env.VELA_PLATFORM_URL

export const LOKI_URL = process.env.LOKI_URL

export const PROJECT_REST_URL = `${PUBLIC_URL.origin}/rest/v1/`
export const PROJECT_ENDPOINT = PUBLIC_URL.host
export const PROJECT_ENDPOINT_PROTOCOL = PUBLIC_URL.protocol.replace(':', '')

export const DEFAULT_HOME = '/org'

export const DEFAULT_PROJECT = {
  id: 1,
  ref: 'default',
  name: 'Default Project',
  organization_id: 1,
  cloud_provider: 'localhost',
  status: 'ACTIVE_HEALTHY',
  region: 'local',
  inserted_at: '2021-08-02T06:40:40.646Z',
}

export const DEFAULT_PROJECT_2 = {
  id: 2,
  ref: 'default2',
  name: 'Second Project',
  organization_id: 1,
  cloud_provider: 'localhost',
  status: 'ACTIVE_HEALTHY',
  region: 'local',
  inserted_at: '2021-08-02T06:40:40.646Z',
}
